import Rails from "@rails/ujs"
import { Controller } from "stimulus"
import { Luminous, LuminousGallery } from 'luminous-lightbox';

export default class extends Controller {
  static targets = ["insurancecard","diagnostic","prescription","tab", "additional","payment","fee"];
  static classes = ["hidden","active"];
  static values = {travellerurl: String};

  connect() {
    const hr_image = document.querySelector(".hr_image");
    const insurance_card_gallery = document.querySelectorAll(".insurance_card_gallery");
    const di_gallery = document.querySelectorAll(".di_gallery");
    const ai_user_gallery = document.querySelectorAll(".user_image_gallery");
    const ai_admin_gallery = document.querySelectorAll(".admin_image_gallery");
    const ai_admin_hidden_gallery = document.querySelectorAll(".admin_hidden_image_gallery");
    if (hr_image != undefined){new Luminous(hr_image);}
    if (insurance_card_gallery != undefined){new LuminousGallery(insurance_card_gallery);}
    if (di_gallery != undefined){new LuminousGallery(di_gallery);}
    if (ai_user_gallery != undefined){new LuminousGallery(ai_user_gallery);}
    if (ai_admin_gallery != undefined){new LuminousGallery(ai_admin_gallery);}
    if (ai_admin_hidden_gallery != undefined){new LuminousGallery(ai_admin_hidden_gallery);}
  }
  tabTargetConnected() {
    const hash = location.hash;
    if(hash){
      const tabName = hash.slice(1);
      this.openContents(tabName);
      const li = document.getElementById(tabName+"Tab");
      this.activeTab(li);
    }
  }

  changeTab(event) {
    event.preventDefault();
    const el = event.currentTarget;
    const params = event.params;

    this.activeTab(el.parentElement);
    if(params.view != null && params.view != ""){
      this.openContents(params.view);
    }
  }

  activeTab(element){
    const tabs = this.tabTarget.children;
    for(const t of tabs){
      t.classList.remove(this.activeClass);
    }
    element.classList.add(this.activeClass);
    location.hash = element.id.slice(0,-3);
  }

  openContents(linkto){
    switch (linkto) {
      case "insurancecard":
        this.insurancecardTarget.classList.remove(this.hiddenClass);
        this.diagnosticTarget.classList.add(this.hiddenClass);
        this.prescriptionTarget.classList.add(this.hiddenClass);
        this.additionalTarget.classList.add(this.hiddenClass);
        this.paymentTarget.classList.add(this.hiddenClass);
        this.feeTarget.classList.add(this.hiddenClass);
        break;
      case "diagnostic":
        this.insurancecardTarget.classList.add(this.hiddenClass);
        this.diagnosticTarget.classList.remove(this.hiddenClass);
        this.prescriptionTarget.classList.add(this.hiddenClass);
        this.additionalTarget.classList.add(this.hiddenClass);
        this.paymentTarget.classList.add(this.hiddenClass);
        this.feeTarget.classList.add(this.hiddenClass);
        break;
      case "prescription":
        this.insurancecardTarget.classList.add(this.hiddenClass);
        this.diagnosticTarget.classList.add(this.hiddenClass);
        this.prescriptionTarget.classList.remove(this.hiddenClass);
        this.additionalTarget.classList.add(this.hiddenClass);
        this.paymentTarget.classList.add(this.hiddenClass);
        this.feeTarget.classList.add(this.hiddenClass);
        break;
      case "additional":
        this.insurancecardTarget.classList.add(this.hiddenClass);
        this.diagnosticTarget.classList.add(this.hiddenClass);
        this.prescriptionTarget.classList.add(this.hiddenClass);
        this.additionalTarget.classList.remove(this.hiddenClass);
        this.paymentTarget.classList.add(this.hiddenClass);
        this.feeTarget.classList.add(this.hiddenClass);
        break;
      case "payment":
        this.insurancecardTarget.classList.add(this.hiddenClass);
        this.diagnosticTarget.classList.add(this.hiddenClass);
        this.prescriptionTarget.classList.add(this.hiddenClass);
        this.additionalTarget.classList.add(this.hiddenClass);
        this.paymentTarget.classList.remove(this.hiddenClass);
        this.feeTarget.classList.add(this.hiddenClass);
        break;
      case "fee":
        this.insurancecardTarget.classList.add(this.hiddenClass);
        this.diagnosticTarget.classList.add(this.hiddenClass);
        this.prescriptionTarget.classList.add(this.hiddenClass);
        this.additionalTarget.classList.add(this.hiddenClass);
        this.paymentTarget.classList.add(this.hiddenClass);
        this.feeTarget.classList.remove(this.hiddenClass);
        break;
    }
  }

  buttonDisabled(event){
    const el = event.currentTarget;
    el.disabled = true;
    el.parentElement.submit();
  }
  confirmDialog(event){
    const params = event.params;
    const confirmed = confirm(params.confirm);
    if (!confirmed){
      event.preventDefault();
    }else{
      event.currentTarget.value = "変更中・・・"
    }
  }

  traveller_flag(event){
    const el = event.currentTarget;
    Rails.ajax({
      url: this.travellerurlValue+"&traveller_flag="+el.checked,
      type: "GET",
      dataType: 'json',
      success: (response)=> {
        alert("更新しました");
      }
    });
  }
}
